// MyStoreCheckout.js
import React from 'react';
import {Elements} from 'react-stripe-elements';

import Checkout from './Checkout';
import CardSection from './CardSection';

class MyStoreCheckout extends React.Component {
  render() {
    return (
      <Elements>
        <CardSection />
      </Elements>
    );
  }
}

export default MyStoreCheckout;
